/// <reference path="../../../typings/tsd.d.ts" /> 
/// <reference path="../../../typings/linq/linq.d.ts" />
module warsApp.models {
    export class ContentManagementModel{
        public contentPagesVisible: boolean = true;
        public menuManagementVisible:boolean = false;
        public siteConfigurationVisible: boolean = false;
        public landingPageConfigurationVisible: boolean = false;


        constructor() {

        }



        public contentPagesSelected() {
            this.contentPagesVisible = true;
            this.menuManagementVisible =false;
            this.siteConfigurationVisible = false;
            this.landingPageConfigurationVisible = false;
        }

        public siteConfigurationSelected() {
            this.contentPagesVisible =false;
            this.siteConfigurationVisible =true;
            this.menuManagementVisible = false;
            this.landingPageConfigurationVisible = false;
        }

        public menuConfigurationSelected() {
            this.menuManagementVisible = true;
            this.siteConfigurationVisible =false;
            this.contentPagesVisible = false;
            this.landingPageConfigurationVisible = false;
        }

        public landingPageConfigurationSelected() {
            this.menuManagementVisible = false;
            this.siteConfigurationVisible = false;
            this.contentPagesVisible = false;
            this.landingPageConfigurationVisible = true;
        }

    }
}